import script from "./MdCardExpandTrigger.vue?vue&type=script&lang=js"
export * from "./MdCardExpandTrigger.vue?vue&type=script&lang=js"

import "./MdCardExpandTrigger.vue?vue&type=style&index=0&id=5e3d58d5&lang=scss"

const __exports__ = script;

export default __exports__